import React from 'react';
import { MessageCircle, Share2 as Share } from 'react-feather';
import Button from 'seedly-component-library/button-new';
import ShareCount from '../ActionBar/ShareCount';

interface OwnProps {
  handleCommentOpen: () => void;
  commentsCount: number;
  shareCount: number;
  bookmarkButton: React.ReactNode;
  onShareClick: () => void;
}

const CommentButton = ({
  handleCommentOpen,
  commentsCount,
  onShareClick = () => {},
  bookmarkButton,
  shareCount,
}: OwnProps) => {
  return (
    <div className="fixed lg:sticky flex justify-center bottom-6 lg:bottom-12 w-full">
      <div className="bg-white flex justify-center gap-3 rounded-[40px] px-4 py-2 items-center shadow-md">
        <Button
          className="px-3 py-2"
          size="sm"
          variant="primaryWhite"
          onClick={handleCommentOpen}
        >
          <MessageCircle className="mr-1 stroke-neutral-700" size={20} />
          <p className="text-sm text-neutral-700 font-medium">
            {commentsCount} comments
          </p>
        </Button>
        <div className="vertical-divider h-6" />
        {bookmarkButton}
        <div
          className="flex gap-2 lg:hidden items-center"
          onClick={onShareClick}
        >
          <Share size={24} />
          <ShareCount count={shareCount} />
        </div>
      </div>
    </div>
  );
};

export default CommentButton;
